import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import TrialModal from "./TrialModal";
import { buildContent } from "./landing/LandingContent";
import LandingNavbar from "./landing/LandingNavbar";
import LandingHero from "./landing/LandingHero";
import LandingSections from "./landing/LandingSections";
import LandingBottom from "./landing/LandingBottom";

export default function LandingPage() {
  const [lang, setLang] = useState("pt-BR");
  const [showTrialModal, setShowTrialModal] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  // Dynamic pricing from backend
  const [pricing, setPricing] = useState({ base_price: 99, extra_user_price: 39.90, included_users: 1 });
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/pricing`)
      .then(r => r.json())
      .then(d => setPricing(d))
      .catch(() => {});
  }, []);

  const fmtPrice = (v) => {
    const n = Number(v);
    return Number.isInteger(n) ? `R$${n}` : `R$${n.toFixed(2).replace(".", ",")}`;
  };
  const bp = fmtPrice(pricing.base_price);
  const ep = fmtPrice(pricing.extra_user_price);
  const iu = pricing.included_users;
  const exampleUsers = 5;
  const exampleTotal = pricing.base_price + (exampleUsers - iu) * pricing.extra_user_price;
  const exampleStr = `${exampleUsers} ${lang === "en-US" ? "users" : lang === "es-ES" ? "usuarios" : "usu\u00e1rios"} = ${bp} + ${exampleUsers - iu}\u00d7${ep} = ${fmtPrice(exampleTotal)}/${lang === "en-US" ? "month" : lang === "es-ES" ? "mes" : "m\u00eas"}`;

  const c = buildContent(bp, ep, iu, exampleStr)[lang];

  useEffect(() => { document.title = "Pipe4.me \u2014 Seu pipeline, sob controle"; }, []);

  const handleCTA = () => setShowTrialModal(true);
  const handleLogin = () => navigate("/login");
  const handleDashboard = () => navigate("/dashboard");

  return (
    <div className="min-h-screen bg-white font-sans" data-testid="landing-page">
      <LandingNavbar c={c} user={user} handleCTA={handleCTA} handleLogin={handleLogin} handleDashboard={handleDashboard} />
      <LandingHero c={c} lang={lang} handleCTA={handleCTA} />
      <LandingSections c={c} lang={lang} handleCTA={handleCTA} />
      <LandingBottom c={c} lang={lang} handleCTA={handleCTA} handleLogin={handleLogin}
        bp={bp} ep={ep} iu={iu} setLang={setLang} exampleStr={exampleStr} />
      {showTrialModal && <TrialModal onClose={() => setShowTrialModal(false)} />}
    </div>
  );
}
